<template>
    <!-- {{ mapList }} -->
    <!-- <p slot="title">锁妖塔</p> -->
    <div>
        <div>
            <Select v-model="mapName" style="width: 50%">
                <!-- ({{ item.minLv }}) -->
                <Option v-for="item in mapList" :value="item.mapName" :name="item.mapId" :key="item.mapId">
                    {{ item.mapName }} {{item.minLv}}-{{item.maxLv}}
                </Option>
            </Select>

            <Button @click.prevent="startTheBattle" size="small" type="info" ghost>
                开始战斗
            </Button>
        </div>

        <div>
          <!-- 统计伤害   -->
          <div v-if="battleTotal" >
            战斗统计：
            <Table  ref="table"  size="small" :columns="columnsBattle" :data="battleTotalList"></Table>
          </div>
            <div class="monster" :class="[monsterList.length == 1 ? 'monstercenter' : '']">
                <Poptip trigger="hover" v-for="item in monsterList" :key="item.id" :title="item.name">
                    ({{ item.prefix == 0 ? "无" : item.prefix }}){{ item.name }}
                    <Progress :percent="(Math.max(item.life, 0) / item.maxLife) * 100">
                        <span>{{ item.life }}</span>
                    </Progress>
                    <div slot="content">
                        <p>生命值 {{ item.life }}</p>
                        <p>最小攻击力 {{ item.attackMin }}</p>
                        <p>最大攻击力 {{ item.attackMax }}</p>
                        <p>防御力 {{ item.defence }}</p>
                        <p>命中率 {{ item.hitRate * 100 }}%</p>
                        <p>闪避率 {{ item.evade * 100 }}%</p>
                        <p>暴击率 {{ item.explode * 100 }}%</p>
                        <p>暴击伤害 {{ item.criDamage * 100 }}%</p>
                        <p>行动速度 {{ item.speed }}</p>
                    </div>
                </Poptip>
            </div>
            <div class="monster" :class="[gameCharacterVO.length == 1 ? 'monstercenter' : '']" v-if="this.teamStatus != 1">
                <Poptip trigger="hover" v-for="(item,idx) in gameCharacterVO" :key="idx" :title="item.name">
                    {{ idx == 0 ? '角色: ' : '真灵: ' }}{{ item.name || '' }}
                    <br>
                    <Progress :percent="(Math.max(item.health || auraLife, 0) / item.formerHealth) * 100" style="width: 200px">
                        <span>{{ item.health || auraLife }}</span>
                    </Progress>
                    <div slot="content">
                        <p>生命值 {{ item.health }}</p>
                        <p>物攻 {{ item.physicalAttack }}</p>
                        <p>法攻 {{ item.magicAttack }}</p>
                        <p>防御力 {{ item.defence }}</p>
                        <p>命中率 {{ item.hitRate * 100 }}%</p>
                        <p>闪避率 {{ item.evade * 100  || 0}}%</p>
                        <p>暴击率 {{ (item.criticalHitValue * 100).toFixed(2)  || 0}}%</p>
                        <p>暴击伤害 {{ (item.critDamage * 100).toFixed(2) || 0 }}%</p>
                        <p>行动速度 {{ item.movingSpeed }}</p>
                    </div>
                </Poptip>
            </div>

            <div class="recording" id="recording">
                <h2 style="margin-top: 20px" v-if="monsterList.length <= 0">暂无记录</h2>
                <battle-process v-bind:recordings="recording"></battle-process>
            </div>
        </div>

    </div>
</template>

  <script>
import battleProcess from "./battleProcess.vue";

import qs from "query-string";
import { sleep } from "../utils";

export default {
    components: { battleProcess },
    name: "lockDemonTower",
    data() {
        return {
            mapList: [],
            mapid: '',
            mapName: '',
            battleTotal: false, // 战斗统计弹出框
            battleTotalList: [],//战斗统计列表
            monsterList: [],
            gameCharacterVO: [],
            recording: [],
            teamStatus: 1,
            columnsBattle: [
              {
                title: '名称',
                key: 'name',
                fixed: 'left',
                width: 200,
              },
              {
                title: '伤害',
                key: 'damage',
                className: 'democolor',
                width: 100,
                sortable: true
              },
              {
                title: '普攻',
                key: 'attack',
                width: 100,
                sortable: true
              },
              {
                title: '力道',
                key: 'lidao',
                width: 100,
                sortable: true
              },
              {
                title: '灵力',
                key: 'lingli',
                width: 100,
                sortable: true
              },
              {
                title: '持续',
                key: 'sustained',
                width: 100,
                sortable: true
              },
              {
                title: '治疗',
                key: 'zhiliao',
                className: 'democolor2',
                width: 100,
                sortable: true
              },
              {
                title: '回蓝',
                key: 'huilan',
                width: 100,
                sortable: true
              },
              {
                title: '反击',
                key: 'counterattack',
                width: 100,
                sortable: true
              },
              {
                title: '被控制',
                key: 'control',
                width: 100,
                sortable: true
              }
            ],
        };
    },
    created() {
        //this.getMapList();
        setInterval(() => {
            this.getMapList();
        }, 10000000);
    },
    updated() {
        // 战斗记录定位到底部
        const el = document.getElementById("recording");
        const max = el.scrollHeight - el.clientHeight;
        if (max - el.scrollTop < 80) {
            el.scrollTop = el.scrollHeight;
        }
    },
    methods: {
        // 返回品质颜色
        distinguishColor(color) {
            if (color == 1) {
                return "#000";
            } else if (color == 2) {
                return "#c5c52f";
            } else if (color == 3) {
                return "#049c04";
            } else if (color == 4) {
                return "#005aff";
            } else if (color == 5) {
                return "#ff00e0";
            } else if (color == 6) {
                return "#ff0000";
            } else if (color == 7) {
                return "#ff8c00";
            } else {
                return "#ff00c3e0";
            }
        },
        getMapList() {
            this.$http.get("gameLockDemon/queryMapList").then((res) => {
                this.mapList = res.data.data;
                if (!res.data.data) {
                    this.$Notice.success({title:res.data.msg});
                }
            }).catch((err) => {
                this.$Notice.warning({title:"获取锁妖塔地图失败,请联系管理员"});
            });
        },
        async startTheBattle() {
            this.mapid = '';
            for (var i = 0; i < this.mapList.length; i++) {
                if (this.mapName == this.mapList[i].mapName) {
                    this.mapid = this.mapList[i].mapId;
                }
            }

            try {
                const res = await this.$http.post(
                    `gameLockDemon/checkMapGenMon?${qs.stringify({
                        charaId: this.getCookie("charaId"),
                        mapId: this.mapid,
                    })}`
                );

                if (res.data.msg != 'OK') {
                    this.$Notice.warning({title:res.data.msg});
                    return
                }

                const body = res.data;

                if (body.status == 205) {
                    this.$Notice.warning({title:body.msg});
                    // await sleep(6000);
                    // this.startTheBattle();
                    return;
                }

                const combatResults = body.data
                // 按顺序播报所有的战斗结果
                for (let i = 0; i < combatResults.length; i++) {
                  //清空战斗统计信息
                    this.battleTotal=false;
                    this.battleTotalList=[];
                    await this.boardcastCombatResult(combatResults[i]);
                }
            } catch (err) {
                this.$Notice.error({title:"战斗开始失败,请联系管理员"});
            }

        },

        // 播报战斗返回的日志
        async boardcastCombatResult(result) {
            this.monsterList = result.gameMonList; // 怪物信息
            this.monsterList.forEach((m) => (m.maxLife = m.life));
            if (this.teamStatus != 1) {
                if (result.gamePetVO) {
                    result.gamePetVO = {
                        health: result.gamePetVO.life,
                        name: result.gamePetVO.auraName,
                        ...result.gamePetVO
                    }
                    this.gameCharacterVO = [result.gameCharacterVO, result.gamePetVO]; // 人物 加宠物信息信息
                    this.gameCharacterVO.forEach((m) => (m.formerHealth = m.health));
                } else {
                    this.gameCharacterVO = [result.gameCharacterVO]; // 人物加信息
                    //this.gameCharacterVO.forEach((m) => (m.maxLife = m.health));
                }
            }
            let combatInfo = result.combatInfo;
            for (let i = 0; i < combatInfo.length; i++) {
                // 每条记录的输出相隔 1.5 秒
                await sleep(1500);
                const record = combatInfo[i];
                //记录战斗统计
                if(this.battleTotalList.length>0){
                  var falg=false;
                  for (let i = 0; i < this.battleTotalList.length; i++) {
                    if(this.battleTotalList[i].name===record.attacker){
                      this.attackTotalDam(record,i);
                      falg=true;
                    }
                  }
                  if(!falg){
                    this.attackTotalDam(record,null);
                  }
                }else{
                  this.attackTotalDam(record,null);
                }
                const targets = this.monsterList.filter(
                    (m) => m.name == record.hinjured
                );
                if (targets.length > 0) {
                    targets[0].life = record.surplusHealth;
                }

                if (this.teamStatus != 1) {
                    const targets1 = this.gameCharacterVO.filter(
                        (m) => m.name == record.hinjured
                    );
                    if (targets1.length > 0) {
                        targets1[0].health = record.surplusHealth;
                    }
                }
                // 1 物理伤害 2灵力伤害 3持续伤害 4恢复血量
                // console.log(record, "战斗日志");
                if (record.hurtType == 5) {
                    record.type = "gain";
                } else {
                    record.type = "combat";
                }
                this.addRecord(record);
            }
            // 额外增加一个战斗结果的消息记录
            if (result.reHealth <= 0) {
                this.addRecord({
                    type: "result",
                    result: "战斗失败",
                });
                this.battleTotal=true;
            } else {
                // 物品列表
                const goods = result.gameItemsList.map((val) => {
                    return val.itemName;
                });
                const droppedGood = goods.length > 0;
                this.addRecord({
                    type: "result",
                    result: "战斗成功",
                    exp: "获得" + result.dropExp + "经验;",
                    goods: "物品:" + (droppedGood ? goods.join() : "无"),
                    reHealth: result.reHealth,
                    reMana: result.reMana,
                });
                this.battleTotal=true;
                if (droppedGood) {
                    // 通知神通刷新检查
                    this.$bus.$emit("skillMsg", "锁妖塔发送过来的");
                    this.$bus.$emit("synthesisMsg", "锁妖塔发送过来的");
                }
            }
        },
        addRecord(record) {
            this.recording.push(record);
            // 战斗记录超过一定条数时移除一部分
            if (this.recording.length >= 200) {
                this.recording.splice(0, 100);
            }
        },
        attackTotalDam(record,value){
          var battle={
            name: "",
            damage: 0,
            attack: 0,
            lidao: 0,
            lingli: 0,
            zhiliao: 0,
            huilan: 0,
            sustained: 0,
            counterattack: 0,
            control: 0,
          };
          if(value!=null){
            battle=this.battleTotalList[value];
          }
          //名称
          battle.name=record.attacker;
          //伤害  record.hurtNum;
          if(record.hurtType===1){
            //hurtType 1 物理伤害
            battle.damage = battle.damage + record.hurtNum;
            if(record.isSkill===0){
              //普攻
              battle.attack = battle.attack + record.hurtNum;
            }else{
              //神通
              battle.lidao = battle.lidao + record.hurtNum;
            }
          }else if(record.hurtType===2){
            //hurtType 2 灵力伤害
            battle.damage = battle.damage + record.hurtNum;
            if(record.isSkill===0){
              //普攻
              battle.attack = battle.attack + record.hurtNum;
            }else{
              //神通
              battle.lingli = battle.lingli + record.hurtNum;
            }
          }else if(record.hurtType===3){
            //hurtType 3 持续伤害
            battle.damage = battle.damage + record.hurtNum;
            battle.sustained = battle.sustained + record.hurtNum;
          }else if(record.hurtType===4){
            //hurtType 4 反击伤害
            battle.counterattack = battle.counterattack + record.hurtNum;
          }else if(record.hurtType===5){
            //hurtType 5 恢复血量
            battle.zhiliao = battle.zhiliao + record.hurtNum;
          }else if(record.hurtType===6){
            //hurtType 6 回复蓝量
            battle.huilan = battle.huilan + record.hurtNum;
          }else if(record.hurtType===7){
            //hurtType 7 回复血量和蓝量
            battle.zhiliao = battle.zhiliao + record.hurtNum;
          }else if(record.hurtType===9){
            //hurtType 9 持续恢复血量
            battle.zhiliao = battle.zhiliao + record.hurtNum;
          }else if(record.hurtType===10){
            //hurtType 10 特殊技能描述
            battle.control = battle.control + 1;
          }
          if(record.hinjuredConmbatList!=null&&record.hinjuredConmbatList.length>0){
            for (let i = 0; i < record.hinjuredConmbatList.length; i++) {
              if(record.hinjuredConmbatList[i].hurtType===10){
                battle.control = battle.control + 1;
              }else {
                //持续技能伤害 敌人给你造成的 需要加载其他的地方
                  for (let t = 0; t < this.battleTotalList.length; t++) {
                    if(this.battleTotalList[t].name===record.hinjuredConmbatList[i].attacker){
                      if(record.hinjuredConmbatList[i].hurtType===9){
                        this.battleTotalList[t].zhiliao = this.battleTotalList[t].zhiliao + record.hinjuredConmbatList[i].hurtNum;
                      }else{
                        this.battleTotalList[t].sustained = this.battleTotalList[t].sustained + record.hinjuredConmbatList[i].hurtNum;
                      }
                    }
                  }
              }
            }
          }
          if(value!=null){
            this.battleTotalList[value]=battle;
          }else{
            this.battleTotalList.push(battle);
          }
        },
    },
};
  </script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
.knapsack > div {
    margin-right: 20px;
    margin-bottom: 20px;
}

.Equipment p {
    color: white;
}

/* 地图和战斗场景 */
.monster {
    display: flex;
    justify-content: space-between;
    /* margin-bottom: 40px; */
    margin-bottom: 8px;
    margin-top: 8px;
}
.monstercenter {
    justify-content: center;
}
.democolor{
  color: red;
}
.democolor2{
  color: green;
}
/*  战斗场景  */
.recording {
    max-height: 174px;
    overflow: auto;
    transition: all 0.4s;
}
</style>



// WEBPACK FOOTER //
// src/components/lockDemonTower.vue